import React from 'react';

import { DynamicProductTable } from '../../_dynamic';

import { tableHead } from './constants';
import ProductItem from './item';

export const FundsTable = (props) => {
  return (
    <DynamicProductTable
      {...props}
      ProductItem={ProductItem}
      tableHeadItems={tableHead}
      tabletColumns={3}
      mobileColumns={1}
      mobileRows={3}
      productType="funds"
      mobileFields={[
        { key: 'fundCnpj', label: 'CNPJ' },
        { key: 'fundCategory', label: 'Categoria' },
        { key: 'fundName', label: 'Nome' },
        { key: 'tags', label: 'Bloqueios' },
      ]}
    />
  );
};
